const i18n = require('@/i18n').default;

export default {
    namespaced: true,
    state: {
        buttons: [
            // {
            //     route: 'home',
            //     src: require('@/assets/images/decoration/link-icon-hi.svg'),
            //     label: 'Intro',
            //     loggedIn: false,
            //     loggedOut: true,
            // },
            {
                route: 'flowers',
                src: require('@/assets/images/decoration/link-icon-flowers.svg'),
                label: i18n.t('LANDING_FLOWERS'),
                loggedIn: false,
                loggedOut: true,
            },
            {
                route: 'delivery',
                src: require('@/assets/images/decoration/link-icon-van.svg'),
                label: i18n.t('LANDING_DELIVERY'),
                loggedIn: false,
                loggedOut: true,
            },
            {
                route: 'arranging',
                src: require('@/assets/images/decoration/link-icon-vase.svg'),
                label: i18n.t('LANDING_ARRANGING'),
                loggedIn: false,
                loggedOut: true,
            },
        ],
    },
    getters: {
        // Gets buttons for navigation bar.
        getButtons: state => state.buttons,
    },
};
